import React, { useState } from 'react';
import { connect } from 'react-redux';

import Typography from '@material-ui/core/Typography';
import { Paper, Tabs, Tab, Box } from '@material-ui/core';

import { ProductsToolbar } from './components';
import { setProducts } from 'actions';
import ProductList, { useStyles } from './productList';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Typography
			component='div'
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	);
}

const ProductListContainer = ({ match, history }) => {
	const [query, setQuery] = useState({
		type: match.params.kind === 'dog' ? '汪星人' : '喵星人',
		name: '',
	});

	const classes = useStyles();

	const onSearch = name => {
		setQuery({
			...query,
			name: name,
		});
	};

	const [pageValue, setPageValue] = useState(
		match.params.kind === 'dog' ? 1 : 0
	);

	const handleChange = (event, pageValue) => {
		setPageValue(pageValue);
		setQuery({
			name: '',
			type: pageValue === 0 ? '喵星人' : '汪星人',
		});

		history.push(`/products/${pageValue === 0 ? 'cat' : 'dog'}`);
	};

	const searchBar = () => (
		<ProductsToolbar placeholder='搜索商品' onSearch={onSearch} />
	);

	return (
		<div className={classes.root}>
			<Paper style={{ marginTop: '20px' }} square>
				<Tabs
					variant='fullWidth'
					value={pageValue}
					indicatorColor='primary'
					textColor='primary'
					onChange={handleChange}
					aria-label='disabled tabs example'
				>
					<Tab label='喵星人' />
					<Tab label='汪星人' />
				</Tabs>
			</Paper>
			<TabPanel value={pageValue} index={0}>
				{searchBar()}
				<ProductList query={query} />
			</TabPanel>
			<TabPanel value={pageValue} index={1}>
				{searchBar()}
				<ProductList query={query} />
			</TabPanel>
		</div>
	);
};

export default connect(null, { setProducts })(ProductListContainer);
